import { useState } from "react";
import { Switch } from "antd";
import { Page } from "../../../helbest";
import HeaderBack from "../../../helbest/HeaderBack/HeaderBack";
import Button from "../../components/ui/Button";
import styles from "./Staffs.module.css";

import { ReactComponent as PlusIcon } from "../../../assets/svg/plus.svg";
import { ReactComponent as TimeIcon } from "../../../assets/svg/time.svg";

import NewStaff from "./NewStaff/NewStaff";

const Staffs = () => {
  const [openNewModal, setOpenNewModal] = useState(false);

  const staffs = [
    {
      name: "David Gill",
      service: 25,
      phone_number: "+968 (778) 991-4433",
      active: true,
    },
    {
      name: "Justus M",
      service: 15,
      phone_number: "+968 (778) 991-4423",
      active: true,
    },
  ];
  return (
    <Page
      showFooter
      customPageClassName="px-3"
      customHeader={<HeaderBack title="My Staffs" url={"/profile/"} />}
      headerFix
      logo
      noFooter
      back
    >
      <div className="flex items-center mt-5 mb-2">
        <Button
          style_backgroundColor="unset"
          style_background="transparent"
          style_fontSize="type-2"
          style_fontWeight="bold"
          style_borderRadius="type-2"
          style_border="1px solid var(--hig-color-primary)"
          style_color="var(--hig-color-primary)"
          style_paddingLeft="12px"
          style_paddingRight="12px"
          onClick={() => setOpenNewModal(true)}
        >
          <PlusIcon className={styles.AddIcon} width={14} />
          Add New Staff
        </Button>
        <NewStaff
          open={openNewModal}
          closeModal={() => setOpenNewModal(false)}
        />
      </div>
      {staffs.map((staff) => {
        return (
          <div className={styles.Box}>
            <div className={styles.BoxRow}>
              <span className={styles.BoxTitle}>{staff.name}</span>
              {staff?.time ? (
                <span>
                  <TimeIcon width={13} className="me-2" />
                  {staff?.time}
                </span>
              ) : (
                <span>Service: {staff.service}</span>
              )}
            </div>
            <div className={styles.BoxRow}>
              <span>{staff.phone_number}</span>
              <Switch checked={staff.active} />
            </div>
          </div>
        );
      })}
    </Page>
  );
};

export default Staffs;
